import { SchoolInput } from '@/core/domain/school/core/School'
import type ISchoolDirectoryRepository from '@/core/domain/school/directory/ISchoolDirectoryRepository.ts'

export default class FetchSchoolDirectoryEntryUseCase {
  readonly schoolDirectoryRepository: ISchoolDirectoryRepository

  constructor(schoolDirectoryRepository: ISchoolDirectoryRepository) {
    this.schoolDirectoryRepository = schoolDirectoryRepository
  }

  async execute(codeUai: string): Promise<SchoolInput> {
    const entry = await this.schoolDirectoryRepository.fetchByCodeUai(codeUai)
    if (entry === null) { return new SchoolInput() }
    return SchoolInput.create({
      name: entry?.name,
      codeUai: entry?.codeUai,
      address: entry?.address,
      city: entry?.city,
      zipCode: entry?.zipCode,
      department: entry?.department,
      schoolDistrict: entry?.schoolDistrict,
      contactEmail: entry?.contactEmail
    })
  }
}
